import { ThisConnector } from '../../../api/connector'
import { UseMutationOptions } from 'react-query'
import { HTTPError } from '../../../api/fetch/decorate-fetch'
import { useContrastMutation } from '../../../hooks/use-contrast-mutation'
import { AgentsResource } from './use-agent-keys'

export interface BaseApiResponse {
  success: boolean
  messages: string[]
  agent: AgentsResource
}

export interface AgentUserForm {
  orgUuid: string
  agentName?: string
}

export async function addAgentUser(
  this: ThisConnector,
  { orgUuid, agentName }: AgentUserForm
) {
  return this.connector.post<BaseApiResponse>(
    `/organizations/${orgUuid}/agent-users`,
    {
      agentName
    }
  )
}

export function useAddAgentUser(
  options: UseMutationOptions<BaseApiResponse, HTTPError, AgentUserForm>
) {
  return useContrastMutation<BaseApiResponse, HTTPError, AgentUserForm>(
    addAgentUser,
    options
  )
}
